import { render, staticRenderFns } from "./inputcheck.vue?vue&type=template&id=96bfd9bc&"
import script from "./inputcheck.js?vue&type=script&lang=js&"
export * from "./inputcheck.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\e-trailor\\Bont\\Frontend\\BontScheduler.Portal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('96bfd9bc')) {
      api.createRecord('96bfd9bc', component.options)
    } else {
      api.reload('96bfd9bc', component.options)
    }
    module.hot.accept("./inputcheck.vue?vue&type=template&id=96bfd9bc&", function () {
      api.rerender('96bfd9bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ClientApp/components/common/inputs/inputcheck.vue"
export default component.exports